const INITIAL_STATE = {
  errors: {},
  // for quote
  list: {},
  addQuote: {},
  updateQuote: {},
  getQuoteDetail: {},
  // for proposal inside quote
  addCommercialProposal: {},
  editCommercialProposalDetail: {},
  getCommercialProposal: {},
  getCommercialProposalDetail: {},
  addInnerProposal: {},
  editInnerProposal: {},
  sendProposalMail: {},
  getProposalPdf: {},
  deleteProposalLineItem: {},
  bdaList: {},
  deleteInnerProposal: {}
}

const proposal = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'CHECK_EMAIL':
    return { ...state, ...INITIAL_STATE, check_email: action.data }
  case 'CHECK_EMAIL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_LIST_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, list: action.data }
  case 'GET_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_QUOTE':
    return { ...state, ...INITIAL_STATE, addQuote: action.data }
  case 'ADD_QUOTE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_QUOTE':
    return { ...state, ...INITIAL_STATE, updateQuote: action.data }
  case 'UPDATE_QUOTE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_QUOTE_DETAIL':
    return { ...state, ...INITIAL_STATE, getQuoteDetail: action.data }
  case 'GET_QUOTE_DETAIL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_COMMERCIAL_PROPOSAL':
    return { ...state, ...INITIAL_STATE, addCommercialProposal: action.data }
  case 'ADD_COMMERCIAL_PROPOSAL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_INNER_COMMERCIAL_PROPOSAL':
    return { ...state, ...INITIAL_STATE, addInnerProposal: action.data }
  case 'ADD_INNER_COMMERCIAL_PROPOSAL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_INNER_COMMERCIAL_PROPOSAL':
    return { ...state, ...INITIAL_STATE, editInnerProposal: action.data }
  case 'UPDATE_INNER_COMMERCIAL_PROPOSAL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_COMMERCIAL_PROPOSAL':
    return { ...state, ...INITIAL_STATE, getCommercialProposal: action.data}
  case 'GET_COMMERCIAL_PROPOSAL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_COMMERCIAL_PROPOSAL_DETAIL':
    return { ...state, ...INITIAL_STATE, getCommercialProposalDetail: action.data}
  case 'GET_COMMERCIAL_PROPOSAL_DETAIL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'PATCH_COMMERCIAL_PROPOSAL':
    return { ...state, ...INITIAL_STATE, editCommercialProposalDetail: action.data}
  case 'PATCH_COMMERCIAL_PROPOSAL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_COMMERCIAL_PROPOSAL_LINE_ITEM':
    return { ...state, ...INITIAL_STATE, deleteProposalLineItem: action.data}
  case 'DELETE_COMMERCIAL_PROPOSAL_LINE_ITEM_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_INNER_PROPOSAL':
    return { ...state, ...INITIAL_STATE, deleteInnerProposal: action.data}
  case 'DELETE_INNER_PROPOSAL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'SEND_COMMERCIAL_PROPOSAL_MAIL':
    return { ...state, ...INITIAL_STATE, sendProposalMail: action.data}
  case 'SEND_COMMERCIAL_PROPOSAL_MAIL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_PROPOSAL_PDF':
    return { ...state, ...INITIAL_STATE, getProposalPdf: action.data}
  case 'GET_PROPOSAL_PDF_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_BDA':
    return { ...state, ...INITIAL_STATE, bdaList: action.data}
  case 'GET_BDA_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default proposal;
